const EVENT_NAMES = Object.freeze({
  READY: 'comparison:ready',
  ACTIVE: 'comparison:active',
  INACTIVE: 'comparison:inactive',
  VEHICLE_ADDED: 'comparison:vehicle-added',
  VEHICLE_REMOVED: 'comparison:vehicle-removed',
  CLEAR_ALL: 'comparison:clear-all',
  MAXIMIZED: 'comparison:maximized',
  MINIMIZED: 'comparison:minimized',
});

export default EVENT_NAMES;
